// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3tC2V","title":"styles_title__38Bek"};